import { fetchJSON } from '@bonnet/next/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

const options = {
    headers: {
        'X-fwd-svc': 'atc',
    },
    credentials: 'same-origin',
    circuitBreaker: {
        id: 'videoPlaylist',
        timeout: 3000,
        resetTimeout: 30000,
        fallback: {},
    },
};
export default (id) => fetchJSON(cmApiUrl('/rest/lsc/video/' + id), options);
